// React import
import * as React from "react";
// Standard layout imports
import { Columns, Column } from "src/components/Layout/Grid";
import Wrapper from "src/components/Wrapper";
import Title from 'src/components/Title';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import Accordion from 'src/components/Accordion';
import AccordionItem from 'src/components/Accordion/AccordionItem';
import CategoryActivitiesComponent from '../Activityies/categoryActivities.component';
import Line from 'src/components/Line';
import { IActivityCategoryModel } from 'src/Entities/ActivityCategory/ActivityCategory';

interface IProps{
    theme: IActivityThemeModel;
    categories: IActivityCategoryModel[];
    onActivitySelected: (detailKursusId:string,themeId: string, categoryId: string) => void
}


class CoursesThemeComponent extends React.Component<IProps> {

  public render() {
    return (
<Wrapper className="pb3">
            {this.props.categories.length > 0 ? (<div>
                <Title className="mb2">
                  {this.props.theme ? this.props.theme.name : ""} Kurser
                </Title>

                <Accordion>
                  {this.props.categories.map(c => (
                    <AccordionItem  key={c.categoryId} title={c.name}>
                      <div className="pb3 pl5 pt2 pr2">
                        <CategoryActivitiesComponent
                        onSelectActivity={this.props.onActivitySelected}
                          categoryId={c.categoryId}
                          themeId={this.props.theme.themeId}
                        />
                      </div>
                    </AccordionItem>
                  ))}
                </Accordion>

                <Line /></div>): null}

          </Wrapper>
          )
        }
    }

    export default CoursesThemeComponent;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Courses/CourseTheme.component.tsx